<template>
  <!-- 平罗总览·二级页面 -->
  <div id="detail_ping" ref="detail_ping">
    <div class="echarts_border">
      <div class="echart_zonglans">
        <div class="echarts_font">
          <img :src="icon_font" class="icon_img" alt="" />
          <span class="people_font">{{ people }}</span>
        </div>
      </div>
      <div id="echart_one"></div>
      <div class="echart_zonglan">
        <div class="echarts_font">
          <img :src="icon_font" class="icon_img" alt="" />
          <span class="people_font">{{ mode }}</span>
        </div>
      </div>
      <div id="echart_two"></div>
      <div class="echart_zonglan">
        <div class="echarts_font">
          <img :src="icon_font" class="icon_img" alt="" />
          <span class="people_font">{{ CPI }}</span>
        </div>
      </div>
      <div id="echart_three"></div>
      <p class="text-center">数据来源：{{ Data_txt }}</p>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  component: {},
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),
      people: "常住人口",
      mode: "生产总值",
      CPI: "人均可支配收入",
      people_num: [],
      people_yaer: [],
      gross_num: [],
      gross_year: [],
      average_year: [],
      cpi_num: [],
      cpi_yaer: [],
      average_num: [],
      Data_txt: "",
    };
  },
  methods: {
    init_one() {
      var _people = plOtherDataInterface.getPopulationFiveYearList();
      this.people_num = _people.map((item) => item.theNumber);
      this.people_yaer = _people.map((item) => item.theYear);

      var myChart = echarts.init(document.getElementById("echart_one"));
      var option = {
        color: ["#F18F5C"],
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const p = Array.isArray(params) ? params[0] : params;
            if (!p || p.data === undefined || p.seriesName === undefined) return '';
            return `<div style="font-size:12px;">常住人口:${p.data}${p.seriesName}</div>`;
          },
        },
        yAxis: {
          name: "单位（万人）",
          type: "value",
          color: "#fff",
          min: 25,
          max: 30,
          splitLine: {
            show: false,
          },
          nameTextStyle: {
            color: "#fff",
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: "#ccc",
              width: 1,
              type: "dashed",
            },
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.people_yaer,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              color: "#ccc",
              width: 1,
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "万人",
            data: this.people_num,
            type: "line",
            lineStyle: {
              color: "#F18F5C",
            },
            label: {
              show: true,
              position: "top",
              color: "#fff",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#F18F5C", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#41717A", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    init_two() {
      var gross = plOtherDataInterface.getGdpFiveYearList();
      this.gross_num = gross.map((item) => item.theNumber);
      this.gross_year = gross.map((item) => item.theYear);
      var myChart = echarts.init(document.getElementById("echart_two"));
      var option = {
        color: ["#7D5EFF"],
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const p = Array.isArray(params) ? params[0] : params;
            if (!p || p.data === undefined || p.seriesName === undefined) return '';
            return `<div style=\"font-size:12px;\">生产总值:${p.data}${p.seriesName}</div>`;
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.gross_year,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
          },
        ],
        yAxis: [
          {
            name: "单位（亿元）",
            type: "value",
            // max: 200,
            min: 100,
            splitNumber: 5,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            nameTextStyle: {
              color: "#fff",
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "亿元",
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#7D5EFF",
            },
            label: {
              show: true,
              color: "#fff",
              position: "top",
            },
            showSymbol: true,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#565EC9",
                },
                {
                  offset: 1,
                  color: "#2D5F90",
                },
              ]),
            },
            data: this.gross_num,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    init_three() {
      var aver = plOtherDataInterface.getPcdiFiveYearList();
      this.aver_num = aver.map((item) => item.theNumber);
      this.aver_yaer = aver.map((item) => item.theYear);
      var cpi = plOtherDataInterface.getCpiFiveYearList();
      this.cpi_num = cpi.map((item) => item.theNumber);
      var myChart = echarts.init(document.getElementById("echart_three"));
      var option = {
        color: ["#FFC32B", "#10FFE1"],
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const items = Array.isArray(params) ? params : [params];
            const safe = items.filter(p => p && p.seriesName !== undefined && p.data !== undefined);
            if (!safe.length) return '';
            return safe.map(p => `<div style=\"font-size:12px;\">${p.seriesName}:${p.data}元</div>`).join('');
          },
        },
        legend: {
          data: [
            {
              name: "农村居民人均可支配收入",
              textStyle: { color: "#fff", fontSize: 16 },
            },
            {
              name: "城镇居民人均可支配收入",
              textStyle: { color: "#fff", fontSize: 16 },
            },
          ],
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: true,
            data: this.aver_yaer,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
          },
        ],
        yAxis: [
          {
            name: "单位(元)",
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
            nameTextStyle: {
              color: "#fff",
            },
            axisLine: {
              show: true,
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "#ccc",
                width: 1,
                type: "dashed",
              },
            },
          },
        ],
        series: [
          {
            name: "农村居民人均可支配收入",
            type: "bar",
            smooth: true,
            showSymbol: true,
            barWidth: "30px",
            label: {
              normal: {
                show: true,
                position: "top",
                color: "#fff",
              },
            },
            data: this.aver_num,
            // 图例颜色
            itemStyle: {
              normal: {
                color: "#FFC32B",
              },
            },
          },
          {
            name: "城镇居民人均可支配收入",
            type: "bar",
            smooth: true,
            showSymbol: true,
            barWidth: "30px",
            label: {
              normal: {
                show: true,
                position: "top",
                color: "#fff",
              },
            },
            data: this.cpi_num,
            itemStyle: {
              normal: {
                color: "#10FFE1",
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 数据来源
    Sources() {
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[0].national;
    },
  },
  mounted() {
    this.init_one();
    this.init_two();
    this.init_three();
    this.Sources();
  },
};
</script>

<style scoped>
#detail_ping {
  background: #15606e;
}
.logo_icon {
  cursor: pointer;
  position: absolute;
  right: 0.625rem;
  top: 1.25rem;
  width: 1.0625rem;
  height: 1.0625rem;
}
.logo_font {
  position: relative;
  padding-bottom: 1.6875rem;
  border-bottom: 1px solid rgb(121, 226, 154);
}
.echart_zonglans {
  margin: 1.875rem 0 0 0;
  border-top: 1px solid rgb(121, 226, 154);
  padding-top: 1.875rem;
}
.echarts_border {
  height: 39rem;
  overflow: auto;
  scrollbar-face-color: #0e4560;
}
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  border-top: 1px dashed rgb(121, 226, 154);
  padding-top: 1.875rem;
}
#echart_one,
#echart_two,
#echart_three {
  height: 18.75rem;
}
.echarts_font {
  text-align: left;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.logo_img {
  width: 6.25rem;
  height: 1.575rem;
  margin-top: 1.25rem;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */
</style>


// WEBPACK FOOTER //
// src/components/pingluo_all/detail_pingluo.vue